import React, { useEffect, useState } from 'react';
import { raiseClaimService } from '../../services';
import { decimalNum, required, policyRegexHyphenSlashScore, noEscChar } from '../../helpers/commonYupValidations';
import { Formik, Form, Field, FieldArray } from 'formik';
import { Table, Button } from 'reactstrap';
import DatePicker from 'react-datepicker';
import moment from "moment";
import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from 'reactstrap';
import { jwtDecode } from 'jwt-decode';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { aesUtil } from '../../utils/aesUtil';

const SalvageAmount = ({ getClaimSettlement, claimDetails, raiseClaimId, fetchClaimTemplateDetails }) => {
    const claimIntimationDate = claimDetails?.claimIntimationDate;
    const parsedclaimIntimationDate = claimIntimationDate ? moment(claimIntimationDate, "DD-MM-YYYY").toDate() : null;

    const [isSubmitted, setIsSubmitted] = useState(false);
    let data = localStorage.getItem('token');
    const decryptToken = typeof data === 'string' ? aesUtil.decrypt(data) : '';
    const decoded = typeof decryptToken === 'string' ? jwtDecode(decryptToken) : null;
    const userRole = decoded?.Role;


    const editClaimSettlementValidationSchema = Yup.object().shape({
        claimSettlementListOnAccount: Yup.array().of(
            Yup.object().shape({
                salvageAmount: Yup.string().matches(noEscChar("Salvage Amount").regex, noEscChar("Salvage Amount").msg).test('onaccountamount-mandatory-validation', 'Salvage Amount is required', function (value) {
                    if (userRole === 'Insurer') {
                        return value;
                    }
                    return true;
                }).test(
                    'is-greater-than-zero',
                    'Salvage Amount must be greater than 0',
                    function (value) {
                        const onAccountAmount = value ? parseFloat(value) : 0;
                        if (onAccountAmount || onAccountAmount == 0) {
                            return (
                                onAccountAmount > 0
                            );
                        } else {
                            return true
                        }
                    }).matches(decimalNum(10, 3, 'Salvage Amount').regex, decimalNum(10, 3, 'Salvage Amount').msg)
                    .required(required('Salvage Amount').msg),
                utrNumber: Yup.string().matches(noEscChar("URT No.").regex, noEscChar("URT No.").msg).max(100, 'UTR No. must be less than 100 characters').matches(policyRegexHyphenSlashScore('UTR No.').regex, policyRegexHyphenSlashScore('UTR No.').msg).test('utr-no-validation', 'UTR No. is required', function (value) {
                    if (userRole === 'Insurer') {
                        return value;
                    }
                    return true;
                })
            })
        ),
    });


    const addClaimSettlement = async (values) => {
        let savageData = values.claimSettlementListOnAccount;
        let payload = {
            claimId: raiseClaimId,
            salvageDatails: savageData
        }

        setIsSubmitted(true)
        const response = await raiseClaimService.addSalvageAmount(payload);
        if (response?.data?.isSuccess) {
            await getClaimSettlement();
            await fetchClaimTemplateDetails(raiseClaimId);
            toast.success(response?.data?.message);
        } else {
            toast.error(response?.data?.message);
        }
        setIsSubmitted(false)
    }

    return (
        <div>
            {/* {!isLoading && */}
            <Formik
                initialValues={{
                    claimSettlementListOnAccount: [{ id: 0, amountType: "Salvage", salvageAmount: "", utrNumber: '', utrDate: null }],
                }}
                validationSchema={editClaimSettlementValidationSchema}
                onSubmit={addClaimSettlement}
            // enableReinitialize
            >
                {({ dirty, errors, touched, setFieldValue, setFieldTouched, values }) => {
                    return <Form>
                        <div>
                            <div className="form-group mb-3">
                                {/* {role === "Surveyor" || claimDetails?.claimStatus === "Settled" ? null : */}
                                <Accordion>
                                    <AccordionItem>
                                        <AccordionHeader style={{ pointerEvents: 'none' }}>
                                            <div>Salvage Amount</div>
                                        </AccordionHeader>
                                        <AccordionBody>
                                            <FieldArray name="claimSettlementList">
                                                {() => (
                                                    <div>
                                                        {values?.claimSettlementListOnAccount?.length > 0 &&
                                                            values?.claimSettlementListOnAccount?.map((settlement, index) => (
                                                                <div className="d-flex flex-wrap" style={{ justifyContent: "space-between" }} key={settlement?.id}>
                                                                    <div className="form-group fieldArrayBox" style={{ width: "35%" }}>
                                                                        <label htmlFor={`claimSettlementListOnAccount.${index}.salvageAmount`}>Amount *</label>
                                                                        <Field
                                                                            type="text"
                                                                            className={`form-control ${touched.claimSettlementListOnAccount?.[index]?.salvageAmount &&
                                                                                errors.claimSettlementListOnAccount?.[index]?.salvageAmount
                                                                                ? "is-invalid"
                                                                                : ""
                                                                                }`}
                                                                            id={`claimSettlementListOnAccount.${index}.salvageAmount`}
                                                                            name={`claimSettlementListOnAccount.${index}.salvageAmount`}
                                                                            placeholder="Enter Salvage Amount"
                                                                        />
                                                                        {errors.claimSettlementListOnAccount?.[index]?.salvageAmount &&
                                                                            touched.claimSettlementListOnAccount?.[index]?.salvageAmount && (
                                                                                <p className="errorMsg">{errors.claimSettlementListOnAccount[index].salvageAmount}</p>
                                                                            )}
                                                                    </div>
                                                                    <div className="form-group fieldArrayBox" style={{ width: "30%" }}>
                                                                        <label htmlFor={`claimSettlementListOnAccount.${index}.utrNumber`}>UTR No.</label>
                                                                        <Field
                                                                            type="text"
                                                                            className={`form-control`}
                                                                            id={`claimSettlementListOnAccount.${index}.utrNumber`}
                                                                            name={`claimSettlementListOnAccount.${index}.utrNumber`}
                                                                            placeholder="Enter UTR Number"
                                                                        />
                                                                        {errors.claimSettlementListOnAccount?.[index]?.utrNumber &&
                                                                            touched.claimSettlementListOnAccount?.[index]?.utrNumber && (
                                                                                <p className="errorMsg">{errors.claimSettlementListOnAccount[index].utrNumber}</p>
                                                                            )}
                                                                    </div>
                                                                    <div className="form-group fieldArrayBox" style={{ width: "30%" }}>
                                                                        <label htmlFor={`claimSettlementListOnAccount.${index}.utrDate`}>UTR Date</label>
                                                                        <DatePicker
                                                                            selected={values.claimSettlementListOnAccount[index].utrDate}
                                                                            onChange={(date) =>
                                                                                setFieldValue(`claimSettlementListOnAccount.${index}.utrDate`, moment(date).format("YYYY-MM-DD"))
                                                                            }
                                                                            dateFormat="dd/MM/yyyy"
                                                                            autoComplete="off"
                                                                            className={`form-control full-width-datepicker`}
                                                                            name={`claimSettlementListOnAccount.${index}.utrDate`}
                                                                            onBlur={() => setFieldTouched(`claimSettlementListOnAccount.${index}.utrDate`, true)}
                                                                            placeholderText="Enter UTR Date"
                                                                            minDate={new Date(parsedclaimIntimationDate)}
                                                                            maxDate={new Date()}
                                                                            onKeyDown={(e) => e.preventDefault()}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            ))}
                                                    </div>
                                                )}
                                            </FieldArray>
                                            <div style={{ display: "flex", justifyContent: "end" }} className='mt-3'>
                                                <Button color="primary" type="submit" className="ITC_Blue_color" disabled={!dirty || isSubmitted || claimDetails?.claimStatus === "Withdrawn"}>
                                                    Submit
                                                </Button>
                                            </div>
                                        </AccordionBody>
                                    </AccordionItem>
                                </Accordion>
                            </div>
                        </div>
                    </Form>
                }}
            </Formik >
            {/* } */}
        </div>
    )
}
export default SalvageAmount

